import { ELanguage, Popup } from '@microfrontends/react-components'
import React, { useContext, useRef } from 'react'
import styled from 'styled-components'
import AppContext from '../../context/AppContext'

import FormCheckNumerology, { RefObj } from './FormCheckNumerology'
interface IProps {
	open: boolean
	onClose: () => void
}

const ContentCss = styled.div`
	padding: 16px;
	display: flex;
	flex-direction: column;
	gap: 16px;
`

export default function ModalFormNumerology({ open, onClose }: IProps) {
	const { t, languageCode } = useContext(AppContext)
	const formRef = useRef<RefObj>(null)
	return (
		<Popup
			styleOption={{
				size: 'md'
			}}
			isShow={open}
			lang={languageCode ?? ELanguage.VI}
			onClose={() => {
				onClose()
				formRef.current?.handleResetFormValues()
			}}
			text={{
				header: t('Tra cứu nhân số học')
			}}
			custom={{ footer: [], bodyOverflow: 'visible' }}
		>
			<ContentCss>
				<FormCheckNumerology handleOpen={onClose} ref={formRef} />
			</ContentCss>
		</Popup>
	)
}
